import { SxProps } from '@mui/material';

export const ComponentSpinnerRingStyles: SxProps = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  justifyContent: 'center',
  overflow: 'auto',
  py: 1,
  width: '100%',
};

export const ComponentSpinnerStyles: SxProps = {
  left: 0,
  position: 'absolute',
  top: 0,
  zIndex: 10,
};
